/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/graph_increase'
export default icon
